import ShareableLinkDocumentsProvider from './ShareableLinkDocuments.provider';

export default ShareableLinkDocumentsProvider;